import langs from './langs'
import { showMethods } from './show-methods'
import { offer } from './templates/imgs'
import { validateOpts } from './validate-opts'
import { offerTextTemplate, offerTextContent } from './templates/text'
import { offerImgTemplate, offerImgContent, mapContent } from './templates/imgs'

export let cachedImgsOffers = []
export let cachedTextOffers = []

export let offersWidget = ({
  url = 'https://www.studentagency.cz/shared/wc/airticket-offers-widget/data.json?id=letenky.cz',
  target = '#offers-widget > .container',
  showOffersBaseInterval = 70,
  showOffersInterval = 70,
  showMethod = 'linear',
  iframeAddress = "",
  randomize = false,
  offers = {
    imgs: [
      {name: 'offer', type: 'big'},
      {name: 'offer', type: 'small'},
      {name: 'offer', type: 'small'},
      {name: 'offer', type: 'small'},
      {name: 'offer', type: 'small'},
      {name: 'map', type: 'small'},
      {name: 'offer', type: 'small'}
    ],
    text: [
      {name: 'offer', type: 'small'},
      {name: 'offer', type: 'small'},
      {name: 'offer', type: 'small'},
      {name: 'offer', type: 'small'}
    ]
  }
} = {}) => {
  const opts = {
    url,
    target,
    showOffersBaseInterval,
    showOffersInterval,
    showMethod,
    offers,
    randomize
  }

  const { imgs, text } = offers

  init()

  function init() {
    if(!validateOpts(opts))
      return

    if(typeof imgs !== 'undefined' && imgs.length > 0) {
      let imgsBlock = `<div class="imgs-offers-block row"><ul>`

      imgs.map(item => imgsBlock += offerImgTemplate(item))
      imgsBlock += '</ul></div>'
      $(imgsBlock).appendTo(target)
    }

    if(typeof text !== 'undefined' && text.length > 0) {
      let textBlock = `<div class="text-offers-block row"><ul>`

      text.map(item => textBlock += offerTextTemplate(item))
      textBlock += '</ul></div>'
      $(textBlock).appendTo(target)
    }

    getData()
  }

  function getData() {
    let totalItems = 0
    if(typeof imgs !== 'undefined') {
      for(let item of imgs) {
        if (item.name === 'offer')
        totalItems++
      }
    }
    if(typeof text !== 'undefined') {
      for(let item of text) {
        if (item.name === 'offer')
        totalItems++
      }
    }

    if(randomize){
      totalItems = 10;
    }

    $.getJSON(`${url}&count=${totalItems}`)
    .then(json => {
      const { data, options } = json
      let item, decrementIndex = false, lastIndex
      let counter = 0
      let loadedImgs = 0
      let shuffledData = [];

      if(randomize){
        shuffledData = shuffle(data);
        shuffledData.sort(function(a, b){
          return parseFloat(a.total) - parseFloat(b.total);
        });
      }else{
        shuffledData = data;
      }



      cachedImgsOffers.map((item, index) => {
        if(counter !== data.length) {
          if(decrementIndex) {
            decrementIndex = false
            index--

          }

          let route = shuffledData[index]
          

          switch(item.name) {
            case ('offer'):
              var img = new Image()
              counter++
              // pokud dany obrazek k nabidce existuje ${iata}-small/big.jpg
              img.onload = function() {
                item = offerImgContent(route, langs[route.type], `${route.journeys[0]['to-iata']}-${item.type}`)

                $(item).appendTo($(`#offers-widget .imgs-offers-block .offer:eq(${index})`)).parent().addClass('test')

                loadedImgs++
              }
              // pokud obrazek k nabidce neexistuje - default-offer-small/big.jpg
              img.onerror = function() {
                item = offerImgContent(route, langs[route.type], `default-offer-${item.type}`)

                $(item).appendTo($(`#offers-widget .imgs-offers-block .offer:eq(${index})`)).parent().addClass('test')

                loadedImgs++
              }

              img.src = `/sys/images/offers/${route.journeys[0]['to-iata']}-${item.type}.jpg`

              break;
            case ('map'):
              decrementIndex = true
              item = mapContent(iframeAddress)

              $(item).appendTo($(`#offers-widget .imgs-offers-block .map`)).parent().addClass('test')

              break;
          }

          lastIndex = index
        }
      })

      // spocitani obrazkovych nabidek (bez mapy)
      let imgsOffers = 0
      for (let i = 0; i < cachedImgsOffers.length; i++) {
        cachedImgsOffers[i].name === 'offer' ? imgsOffers++ : ''
      }
      // ceka se, az skript zkontroluje obrazky (loadedImgs)
      let timer = setInterval(() => {
        // pokud se pocet nactenych obrazku rovna zacahevoanym nabidkam,
        // nebo pokud se pocet nactenych obrazku rovna nebo je mensi nabidkam zikanych ze serveru
        // stavalo se totiz to, ze prichazely napr. jen 3 nabidky ze serveru a pote se nezobrazila ani jedna (loadedImgs se pote nerovnal imgsOffers)
        if(loadedImgs === imgsOffers || loadedImgs >= data.length) {
          clearInterval(timer)

          cachedTextOffers.map((item, index) => {
            if(counter !== data.length) {
              lastIndex++
              let route = data[lastIndex]

              if(typeof item.name === 'undefined')
                return

              switch(item.name) {
                case ('offer'):
                  item = offerTextContent(route)
                  $(item).appendTo($(`#offers-widget .text-offers-block .offer:eq(${index})`)).parent().addClass('test')

                  counter++

                  break;
              }
            }
          })

          if(typeof showMethods[showMethod] === 'function' && typeof showMethods[showMethod] !== 'undefined')
            showMethods[showMethod](opts)
        }
      }, 10)
    })
    .fail(err => {
      console.error('Error loading data', err)
    })
  }

  function shuffle(array) {
  var currentIndex = array.length, temporaryValue, randomIndex;

  while (0 !== currentIndex) {

    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex -= 1;
    
    temporaryValue = array[currentIndex];
    array[currentIndex] = array[randomIndex];
    array[randomIndex] = temporaryValue;
  }

  return array.slice(0,4);
}


}



// WEBPACK FOOTER //
// ./src/js/offers/main.js